import { v4 as uuid } from "uuid";

import { Preview } from "@creatomate/preview";

import reorderTracks from "./reorderTracks";

const createElement = async (
  elementSource: Record<string, any>,
  preview: Preview,
  setActiveElement = true
): Promise<string | undefined> => {
  if (!preview || !preview.state) return undefined;

  const source = preview.getSource();
  const newTrack = Math.max(...preview.state.elements.map((element: any) => element.track)) + 1;

  const id = elementSource.id || uuid();

  source.elements.push({
    id,
    track: newTrack,
    ...elementSource
  });

  await preview.setSource(source, true);

  if (setActiveElement) preview.setActiveElements([id]);

  await reorderTracks(elementSource.track || newTrack, preview);
  return id;
};

export default createElement;
